// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  border-radius: 0;
  --ion-background-color: var(--planeed-color-white);
  margin: 0;
}
@media only screen and (min-width: 460px) {
  ion-card {
    border-radius: 10px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
    margin: 20px 10px;
    background: var(--planeed-color-white);
  }
}

ion-list {
  padding: 0;
  margin: 0;
}

ion-row {
  margin: 0;
}
ion-row ion-icon {
  padding: 4px 0 0 0;
  width: 13px;
  height: 13px;
}

p {
  display: inline;
}

.social-counter {
  margin-bottom: 10px;
  color: var(--ion-color-medium);
  padding: 4px 10px 0 4px;
}

.social-counter span {
  margin: 0 10px 0 5px;
  font-size: 13px;
}

.avatar-box {
  height: 100%;
  padding-top: 16px;
}

ion-item img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  margin: 0 10px 0 0;
  border-radius: 50%;
}

h3 {
  font-size: 15px;
}

.impact-score-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -12px;
  position: absolute;
  margin-left: -12px;
  width: 26px;
  font-size: 15px;
}

.score-heading {
  text-align: center;
  color: var(--ion-color-medium);
}

.score-content-center2 {
  font-size: 16px;
  color: var(--ion-color-warning);
  text-align: center;
  padding-top: 32px;
}

.impact-score-box {
  border: 2px solid var(--ion-color-warning);
  width: 64px;
  height: 64px;
  text-align: center;
  font-size: 16px;
  position: relative;
  border-radius: 50%;
  color: var(--ion-color-warning);
  margin: 0 auto;
}

.score-content {
  position: relative;
  margin-top: -80px;
  padding-bottom: 16px;
}

.content {
  width: 70px;
  text-align: right;
}

.member-type {
  --padding-start: 0px;
  width: 180px;
}

ion-select, p {
  padding: 0;
  margin: 0;
  color: var(--ion-color-secondary);
  font-size: 12px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
